module.exports = "/_next/static/images/diamonds-54d1ffd5a888eec5c63bd21622893c40.png";